<template>
    <div id="produtos">
        <div class="produtos-titulo">
            <img src="@/assets/icon-esquerda-cima.png" alt="">
            <h2>Confira os nossos produtos</h2>
            <img src="@/assets/icon-direita-baixo.png" alt="">
        </div>
        <Produtos />
        
       
    </div>
</template>

<script>
import Produtos from '@/views/ProdutosHome'

export default {

    name: "Produtoss",
    components: { Produtos }
    
}
</script>

<style>
    #produtos {
        margin-bottom: 40px;
    }

    .produtos-titulo {
        width: 100%;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #e17e4b;
        margin-bottom: 40px;
    }

    .produtos-titulo img {
        width: 40px;
        margin-left: 30px;
        margin-right: 30px;
    }

    .produtos-titulo h2 {
        text-transform: uppercase;
        font-weight: 400;
        color: white;
    }

    .produtos-cards {
        margin: 0 auto;
        max-width: 1100px;
    }

    .produto-card {
        width: 300px;
        border-radius: 20px;
        position: relative;
        padding: 40px;
    }

    .produto-card .imagem {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        width: 100%;
        border-radius: 20px;
        position: relative;
     }

    .produto-card .imagem img {
        height: 400px;
        width: 100%;
        border-radius: 15px;
        transition: .5s;
    }

    .produto-card .descricao {
        position: absolute;
        bottom: 0;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 50px;
        background: black;
        border-bottom-right-radius: 15px;
        border-bottom-left-radius: 15px;
        animation: slide- .5s ease forwards;
        opacity: 1;
        transition: .5s;
    }

    .produto-card .descricao h4 {
        color: white;
    }

    .produto-card:hover .descricao {
        opacity: 0;
        transition: .5s;
    }

    .produto-card:hover .imagem img {
        transform: scale(1.1);
        overflow: hidden;
        transition: .5s;
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .produtos-titulo {
            flex-direction: column;
            height: 100%;
        }
        .produtos-titulo h2 {
            margin-left: 20px;
            margin-right: 20px;
            text-align: center;
        }

        .produtos-titulo img {
            margin: 20px;
        }

            .produto-card .imagem img {
        height: 300px;
            }
    } 


</style>